import { createRouter, createWebHistory } from 'vue-router';
import LoginView from '../views/LoginView.vue';
import store from '@/store';

// Function to handle chunk loading errors
const lazyLoadView = (view) => {
  const componentImport = () => import(/* webpackChunkName: "[request]" */ `../views/${view}.vue`);
  
  return () => componentImport().catch((error) => {
          // If error is related to chunk loading, reload the page
    if (error.name === 'ChunkLoadError') {
      window.location.reload();
    }
    throw error;
  });
};

const routes = [
  {
    path: '/',
    name: 'login',
    component: LoginView,
    meta: { showNavBar: false, showCanvasBG: true }
  },
  {
    path: '/login',
    name: 'login-alt',
    redirect: '/'
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: lazyLoadView('DashboardView'),
    meta: { showNavBar: true, showCanvasBG: false, requiresAuth: true }
  },
  {
    path: '/requests',
    name: 'requests',
    component: lazyLoadView('RequestsView'),
    meta: { showNavBar: true, showCanvasBG: false, requiresAuth: true }
  },
  {
    path: '/requests/:id',
    name: 'request-details',
    component: lazyLoadView('RequestDetailsView'),
    meta: { showNavBar: true, showCanvasBG: false, requiresAuth: true },
    props: true
  },
  {
    path: '/account',
    name: 'account',
    component: lazyLoadView('AccountView'),
    meta: { showNavBar: true, showCanvasBG: false, requiresAuth: true }
  },
  {
    path: '/users',
    name: 'users',
    component: lazyLoadView('UsersView'),
    meta: { showNavBar: true, showCanvasBG: false, requiresAuth: true }
  }
];

const router = createRouter({
  // Use createWebHistory with proper base path
  history: createWebHistory('/'),
  routes
});

// Navigation guard
router.beforeEach((to) => {
  // Проверяем, залогинен ли пользователь
  const isLogged = store.state.users.user.isLogged;
  const token = localStorage.getItem('ahToken');
  const hasLocalToken = !!token && localStorage.getItem('ahIsLogged') === 'true';

  // Если маршрут требует авторизации и пользователь не залогинен
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isLogged && !hasLocalToken) {
      // Перенаправление на страницу входа
      return { name: 'login' };
    } 
    // Пользователь авторизован, продолжаем навигацию
    return true;
  } else if (to.name === 'login' && (isLogged || hasLocalToken)) {
    // Если пользователь залогинен и пытается перейти на страницу входа
    return { name: 'dashboard' };
  } 
  // Для маршрутов, не требующих авторизации
  return true;
});

// Добавление нового маршрута в историю навигации
router.afterEach((to, from) => {
  // Добавляем в историю только если маршрут требует отображение навбара
  if (to.meta.showNavBar) {
    store.dispatch('navigation/addToHistory', {
      path: to.path,
      name: to.name,
      meta: to.meta
    });
  }
});

export default router;
